module.exports = __webpack_public_path__ + "images/emoji/footprints.c0ff5f3655b193ad6f91.png";